"use strict";
// @ts-ignore
try {
    self['workbox:expiration:6.5.3'] && _();
}
catch (e) { }
